import en_admin_hub from "@/locale/en/admin_hub.json";
import en_admin_links from "@/locale/en/admin_links.json";
import en_agency_profile from "@/locale/en/agency_profile.json";
import en_ai_campaign_creation from "@/locale/en/ai_campaign_creation.json";
import en_boost_estimate from "@/locale/en/boost_estimate.json";
import en_brand_explore from "@/locale/en/brand_explore.json";
import en_campaign_active from "@/locale/en/campaign_active.json";
import en_campaign_application from "@/locale/en/campaign_application.json";
import en_campaign_creation from "@/locale/en/campaign_creation.json";
import en_campaign_list from "@/locale/en/campaign_list.json";
import en_campaign_overview from "@/locale/en/campaign_overview.json";
import en_campaign_preparation from "@/locale/en/campaign_preparation.json";
import en_campaign_reporting from "@/locale/en/campaign_reporting.json";
import en_chat from "@/locale/en/chat.json";
import en_common from "@/locale/en/common.json";
import en_company_profile from "@/locale/en/company_profile.json";
import en_content_approval from "@/locale/en/content_approval.json";
import en_customer_list from "@/locale/en/customer_list.json";
import en_customer_success from "@/locale/en/customer_success.json";
import en_errors from "@/locale/en/errors.json";
import en_feedback from "@/locale/en/feedback.json";
import en_getting_started from "@/locale/en/getting_started.json";
import en_groups from "@/locale/en/groups.json";
import en_impersonate from "@/locale/en/impersonate.json";
import en_influencer_discipline from "@/locale/en/influencer_discipline.json";
import en_influencer_invite from "@/locale/en/influencer_invite.json";
import en_influencer_list from "@/locale/en/influencer_list.json";
import en_influencer_profile from "@/locale/en/influencer_profile.json";
import en_invoices from "@/locale/en/invoices.json";
import en_media_library from "@/locale/en/media_library.json";
import en_multi_account from "@/locale/en/multi_account.json";
import en_navigation from "@/locale/en/navigation.json";
import en_notifications from "@/locale/en/notifications.json";
import en_payment_errors from "@/locale/en/payment_errors.json";
import en_payments from "@/locale/en/payments.json";
import en_plans from "@/locale/en/plans.json";
import en_referral from "@/locale/en/referral.json";
import en_register from "@/locale/en/register.json";
import en_search_visibility from "@/locale/en/search_visibility.json";
import en_settings from "@/locale/en/settings.json";
import en_unsubscribe from "@/locale/en/unsubscribe.json";
import en_verify_account from "@/locale/en/verify_account.json";
import de_admin_hub from "@/locale/ger/admin_hub.json";
import de_admin_links from "@/locale/ger/admin_links.json";
import de_agency_profile from "@/locale/ger/agency_profile.json";
import de_ai_campaign_creation from "@/locale/ger/ai_campaign_creation.json";
import de_boost_estimate from "@/locale/ger/boost_estimate.json";
import de_brand_explore from "@/locale/ger/brand_explore.json";
import de_campaign_active from "@/locale/ger/campaign_active.json";
import de_campaign_application from "@/locale/ger/campaign_application.json";
import de_campaign_creation from "@/locale/ger/campaign_creation.json";
import de_campaign_list from "@/locale/ger/campaign_list.json";
import de_campaign_overview from "@/locale/ger/campaign_overview.json";
import de_campaign_preparation from "@/locale/ger/campaign_preparation.json";
import de_campaign_reporting from "@/locale/ger/campaign_reporting.json";
import de_chat from "@/locale/ger/chat.json";
import de_common from "@/locale/ger/common.json";
import de_company_profile from "@/locale/ger/company_profile.json";
import de_content_approval from "@/locale/ger/content_approval.json";
import de_customer_list from "@/locale/ger/customer_list.json";
import de_customer_success from "@/locale/ger/customer_success.json";
import de_errors from "@/locale/ger/errors.json";
import de_feedback from "@/locale/ger/feedback.json";
import de_getting_started from "@/locale/ger/getting_started.json";
import de_groups from "@/locale/ger/groups.json";
import de_impersonate from "@/locale/ger/impersonate.json";
import de_influencer_discipline from "@/locale/ger/influencer_discipline.json";
import de_influencer_invite from "@/locale/ger/influencer_invite.json";
import de_influencer_list from "@/locale/ger/influencer_list.json";
import de_influencer_profile from "@/locale/ger/influencer_profile.json";
import de_invoices from "@/locale/ger/invoices.json";
import de_media_library from "@/locale/ger/media_library.json";
import de_multi_account from "@/locale/ger/multi_account.json";
import de_navigation from "@/locale/ger/navigation.json";
import de_notifications from "@/locale/ger/notifications.json";
import de_payment_errors from "@/locale/ger/payment_errors.json";
import de_payments from "@/locale/ger/payments.json";
import de_plans from "@/locale/ger/plans.json";
import de_referral from "@/locale/ger/referral.json";
import de_register from "@/locale/ger/register.json";
import de_search_visibility from "@/locale/ger/search_visibility.json";
import de_settings from "@/locale/ger/settings.json";
import de_unsubscribe from "@/locale/ger/unsubscribe.json";
import de_verify_account from "@/locale/ger/verify_account.json";
import i18next, {default as i18n} from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resourcesDe = {
  admin_hub: de_admin_hub,
  admin_links: de_admin_links,
  agency_profile: de_agency_profile,
  ai_campaign_creation: de_ai_campaign_creation,
  boost_estimate: de_boost_estimate,
  brand_explore: de_brand_explore,
  campaign_active: de_campaign_active,
  campaign_application: de_campaign_application,
  campaign_creation: de_campaign_creation,
  campaign_list: de_campaign_list,
  campaign_overview: de_campaign_overview,
  campaign_preparation: de_campaign_preparation,
  campaign_reporting: de_campaign_reporting,
  chat: de_chat,
  common: de_common,
  company_profile: de_company_profile,
  content_approval: de_content_approval,
  customer_list: de_customer_list,
  customer_success: de_customer_success,
  errors: de_errors,
  feedback: de_feedback,
  getting_started: de_getting_started,
  groups: de_groups,
  impersonate: de_impersonate,
  influencer_discipline: de_influencer_discipline,
  influencer_invite: de_influencer_invite,
  influencer_list: de_influencer_list,
  influencer_profile: de_influencer_profile,
  invoices: de_invoices,
  media_library: de_media_library,
  multi_account: de_multi_account,
  navigation: de_navigation,
  notifications: de_notifications,
  payment_errors: de_payment_errors,
  payments: de_payments,
  plans: de_plans,
  referral: de_referral,
  register: de_register,
  search_visibility: de_search_visibility,
  settings: de_settings,
  unsubscribe: de_unsubscribe,
  verify_account: de_verify_account,
} as const;

const resourcesEn = {
  admin_hub: en_admin_hub,
  admin_links: en_admin_links,
  agency_profile: en_agency_profile,
  ai_campaign_creation: en_ai_campaign_creation,
  boost_estimate: en_boost_estimate,
  brand_explore: en_brand_explore,
  campaign_active: en_campaign_active,
  campaign_application: en_campaign_application,
  campaign_creation: en_campaign_creation,
  campaign_list: en_campaign_list,
  campaign_overview: en_campaign_overview,
  campaign_preparation: en_campaign_preparation,
  campaign_reporting: en_campaign_reporting,
  chat: en_chat,
  common: en_common,
  company_profile: en_company_profile,
  content_approval: en_content_approval,
  customer_list: en_customer_list,
  customer_success: en_customer_success,
  errors: en_errors,
  feedback: en_feedback,
  getting_started: en_getting_started,
  groups: en_groups,
  impersonate: en_impersonate,
  influencer_discipline: en_influencer_discipline,
  influencer_invite: en_influencer_invite,
  influencer_list: en_influencer_list,
  influencer_profile: en_influencer_profile,
  invoices: en_invoices,
  media_library: en_media_library,
  multi_account: en_multi_account,
  navigation: en_navigation,
  notifications: en_notifications,
  payment_errors: en_payment_errors,
  payments: en_payments,
  plans: en_plans,
  referral: en_referral,
  register: en_register,
  search_visibility: en_search_visibility,
  settings: en_settings,
  unsubscribe: en_unsubscribe,
  verify_account: en_verify_account,
} as const;

i18n.use(LanguageDetector).init({
  resources: {
    en: resourcesEn,
    ger: resourcesDe,
  },
  fallbackLng: "ger",
  debug: false,
  ns: ["common", "verify_account"],
  defaultNS: "common",
  keySeparator: false, // we use content as keys
  interpolation: {
    escapeValue: false, // not needed for react !!
    formatSeparator: ",",
  },
  react: {
    useSuspense: false,
  },
});

// Custom formatter for forming the possessive case in translations (e.g. "XY's something")
i18n.services.formatter?.add("possessive", value => {
  const lang = i18next.resolvedLanguage;

  if (lang === "en") return value.endsWith("s") ? `${value}'` : `${value}'s`;

  return value.endsWith("s") || value.endsWith("ß") || value.endsWith("z") || value.endsWith("x")
    ? `${value}'`
    : `${value}'s`;
});

export {i18n, resourcesDe, resourcesEn};
